import { styled } from '@material-ui/styles';
import React from 'react';

import { BaseDialog } from '../../../../../Plugins/FloorPlan/Widgets/BaseDialog';
import { ButtonVariant, CustomButton } from '../../../../Components/Views/CustomButton/CustomButton';

export type SingleChoiceDialogProps = {
    id?: string;
    title?: string;
    body?: React.ReactNode;
    labelChoice?: React.ReactNode;
    onClose?: VoidFunction;
    cancelDisabled?: boolean;
    enableCloseOutside?: boolean;
    onClickChoice: (setValidating: (validating: boolean) => void) => void;
    styles?: { content?: React.CSSProperties };
};

export const SingleChoiceDialog = ({
    id,
    children,
    title,
    labelChoice,
    body,
    onClose,
    cancelDisabled,
    enableCloseOutside,
    onClickChoice,
    styles,
}: React.PropsWithChildren<SingleChoiceDialogProps>) => {
    const [validating, setValidating] = React.useState(false);
    const onValidate = () => onClickChoice(setValidating);
    return (
        <BaseDialog
            id={id}
            title={title}
            subtitle={body}
            onClose={onClose}
            cancelDisabled={cancelDisabled}
            enableCloseOutside={enableCloseOutside}
            styles={styles}>
            <Content>
                <CustomButton
                    title={labelChoice}
                    styles={{ root: { flex: 1 } }}
                    variant={ButtonVariant.Blue}
                    onClick={onValidate}
                    isBusy={validating}
                />
            </Content>
            {children}
        </BaseDialog>
    );
};

const Content = styled('div')({ marginTop: 37, display: 'flex', gap: 12 });
